import React from 'react';
import './ticket-price-calculator.scss'

export class TicketPriceCalculator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fundingAllocation: '',
      expectedStudentAttendance: '',
      studentTicketPrice: '',
      nonStudentTicketPrice: '',
      formErrors: {
        fundingAllocation: '',
        expectedStudentAttendance: '',
        studentTicketPrice: ''
      },
      allocationValid: false,
      attendanceValid: false,
      studentPriceValid: false,
      formValid: false
    };
  }

  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  }

  validateField(fieldName, value) {
    let formValidationErrors = this.state.formErrors;

    let allocationValid = this.state.allocationValid;
    let attendanceValid = this.state.attendanceValid;
    let studentPriceValid = this.state.studentPriceValid;

    switch (fieldName) {
      case 'fundingAllocation':
        allocationValid = this.isNumber(value);
        formValidationErrors.fundingAllocation = allocationValid ? '' : ' must be a number';
        break;
      case 'expectedStudentAttendance':
        attendanceValid = this.isNumber(value);
        formValidationErrors.expectedStudentAttendance = attendanceValid ? '' : ' must be a number';
        break;
      case 'studentTicketPrice':
        studentPriceValid = this.isNumber(value);
        formValidationErrors.studentTicketPrice = studentPriceValid ? '' : ' must be a number';
        break;
      default:
        break;
    }

    this.setState({
      formErrors: formValidationErrors,
      allocationValid: allocationValid,
      attendanceValid: attendanceValid,
      studentPriceValid: studentPriceValid
    }, this.validateForm);
  }

  isNumber(num) {
    return !isNaN(parseFloat(num)) && isFinite(num);
  }

  validateForm() {
    this.setState({ formValid: this.state.allocationValid && this.state.attendanceValid && this.state.studentPriceValid });
  }

  errorClass(error) {
    return error.length === 0 ? '' : 'has-error';
  }

  handleSubmit = (e) => {
    const allocation = +this.state.fundingAllocation;
    const attendance = +this.state.expectedStudentAttendance;
    const studentPrice = +this.state.studentTicketPrice;

    const nonStudentPrice = ((allocation / attendance) + studentPrice).toFixed(2);
    this.setState({ nonStudentTicketPrice: nonStudentPrice });
    e.preventDefault();
  }

  render() {
    return (
      <form className="ticket-price-calculator">
        <div className="header">Ticket Price Calculator</div>

        <div className="form-group">
          <div className="column left">
            <label htmlFor="fundingAllocation">SGA Funding Allocation</label>
          </div>
          <div className="column right">
            <input type="text" required className={`form-control ${this.errorClass(this.state.formErrors.fundingAllocation)}`} name="fundingAllocation"
              placeholder="30.00"
              value={this.state.fundingAllocation}
              onChange={this.handleUserInput} />
          </div>
        </div>

        <div className="form-group">
          <div className="column left">
            <label htmlFor="expectedStudentAttendance">Expected Student Attendance</label>
          </div>
          <div className="column right">
            <input type="text" required className={`form-control ${this.errorClass(this.state.formErrors.expectedStudentAttendance)}`} name="expectedStudentAttendance"
              placeholder="20"
              value={this.state.expectedStudentAttendance}
              onChange={this.handleUserInput} />
          </div>
        </div>

        <div className="form-group">
          <div className="column left">
            <label htmlFor="studentTicketPrice">Student Ticket Price</label>
          </div>
          <div className="column right">
            <input type="text" required className={`form-control ${this.errorClass(this.state.formErrors.studentTicketPrice)}`} name="studentTicketPrice"
              placeholder="20.00"
              value={this.state.studentTicketPrice}
              onChange={this.handleUserInput} />
          </div>
        </div>

        <div className="form-group">
          <div className="column left">
            <label htmlFor="nonStudentTicketPrice">Non-Student Ticket Price</label>
          </div>
          <div className="column right">
            <input className="form-control readonly" readOnly value={this.state.nonStudentTicketPrice} />
          </div>
        </div>

        <button type="submit" className="btn btn-primary"
          disabled={!this.state.formValid}
          onClick={this.handleSubmit}>Calculate Price</button>
      </form>
    )
  }
}

export default TicketPriceCalculator;
